export const LoadingIcon = () => {
  return (
    <svg
      className="h-12 w-12 text-blue-500 animate-spin"
      stroke="#0960FB"
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height="2em"
      width="2em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 3a9 9 0 1 0 9 9"></path>
    </svg>
  );
};
